import { useEffect, useState } from "react";
import { api_private_get } from "script";
import "../../../components/BalanceHistoryTable.css";

function formatTransactionAmount(amount, currency) {
  const normalizedCurrency = currency?.toLowerCase();
  if (!["cad", "cr"].includes(normalizedCurrency)) return amount;

  const numericAmount = Number(amount);
  return Number.isFinite(numericAmount)
    ? numericAmount.toLocaleString(
        normalizedCurrency === "cad" ? "en-CA" : "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      )
    : amount;
}

function TransactionRow({ transaction }) {
  const status = transaction.status?.toLowerCase() || "unknown";
  const statusClass = {
    completed: "text-success",
    pending: "text-warning",
    failed: "text-danger",
  }[status];

  return (
    <tr className="balance-history-row" key={transaction.tx_id}>
      <td data-label="Transaction ID" className="font-monospace text-nowrap">
        <span className="balance-history-id">
          {transaction.tx_id?.toUpperCase()}
        </span>
      </td>
      <td data-label="Date">
        {new Date(transaction.date)?.toLocaleString()}
      </td>
      <td data-label="Type">
        {transaction.type ? transaction.type.toUpperCase() : "N/A"}
      </td>
      <td data-label="Method / Currency">
        {transaction.method ? transaction.method.toUpperCase() : "N/A"} (
        {transaction.currency ? transaction.currency.toUpperCase() : "N/A"})
      </td>
      <td data-label="Amount">
        {formatTransactionAmount(transaction.amount, transaction.currency)}{" "}
        {transaction.currency ? transaction.currency.toUpperCase() : "N/A"}
      </td>
      <td
        data-label="Status"
        className={`balance-history-status fw-normal ${statusClass || ""}`}
      >
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </td>
    </tr>
  );
}

export default function BalanceHistoryTab() {
  const [accountBalanceHistoryData, setAccountBalanceHistoryData] =
    useState(null);

  // const handleChangeDisplayName = (e) => {
  //     e.preventDefault();
  //     console.log("Changing display name to:", newDisplayName);
  //     api_private_post('/account/set_preferences', { display_name: newDisplayName }, () => {
  //         // wait 100 ms to ensure the backend has processed the change
  //         // setTimeout(() => {
  //         fetchProfileData(); // Refresh the profile data after changing display name
  //         showAlert("Preference saved!", "success");
  //         // clear the input field
  //         setNewDisplayName('');
  //         // }, 1);
  //     });
  // };

  const fetchBalanceHistoryData = () => {
    api_private_get("/wallet/get_transactions", (data) => {
      console.log("get_balance_history data:", data);
      setAccountBalanceHistoryData(data);
    });
  };

  useEffect(() => {
    fetchBalanceHistoryData();
  }, []);

  return (
    <div>
      <div className="pay_method__tabletwo balance-history-table-container">
        <div className="pay_method__table-scrollbar">
          <table className="w-100 text-center p2-bg" id="balance-history-table">
            <thead>
              <tr>
                {/* <th className="text-nowrap"></th> */}

                <th className="text-nowrap">Transaction ID</th>
                <th className="text-nowrap">Date</th>
                <th className="text-nowrap">Transaction type</th>
                <th className="text-nowrap">Method/Currency</th>
                <th className="text-nowrap">Amount</th>
                <th className="text-nowrap">Status</th>
              </tr>
            </thead>
            <tbody>
              {/* <!-- <tr>
                                <td className="text-nowrap">2PQ8B4KYMJ</td>
                                <td className="text-nowrap">27.12.2023, 11:31</td>
                                <td className="text-nowrap">Deposit</td>
                                <td className="text-nowrap">Interac eTransfer (CAD)</td>
                                <td className="text-nowrap">5,591 USD</td>
                                <td className="n4-color fw-normal cpoint text-nowrap">Complete</td>
                            </tr> --> */}
              {accountBalanceHistoryData &&
                Object.values(accountBalanceHistoryData).map((transaction) => (
                  <TransactionRow
                    key={transaction.tx_id}
                    transaction={transaction}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
